module.exports = __webpack_public_path__ + "img/module9.47d2b772.png";